<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-06-19 14:50:22
 * @LastEditTime : 2025-06-27 11:34:57
 * @LastEditors  : yangxr
 * @Description  : 供应商台账截图
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\accountingSheet\report\supplierTableImg.vue
-->
<template>
  <div>
      <!-- <div class="card_nav">
          <div></div>
          <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                      <span class="el-icon--left">
                          <i class="iconfont iconicon_button_filtrate"></i>
                      </span>
                      筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in table" :key="index">
                          <el-checkbox v-model="item.status" @change="changeTable">{{ item.label }}</el-checkbox>
                      </el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
          </div>
      </div> -->
      <div class="card_info">
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :height="height > 0 ? height : ''" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index) in table">
                  <el-table-column v-if="item.children" :key="`children-${index}`" :label="item.label" align="center"
                      :width="item.width" :prop="item.prop">
                      <template v-for="(item2, index2) in item.children">
                          <el-table-column v-if="item2" :key="index2" :label="item2.label" align="center"
                              :width="item2.width" :prop="item2.prop">
                              <template slot-scope="scope">
                                  <span>{{ scope.row[item2.prop] }}</span>
                              </template>
                          </el-table-column>
                      </template>
                  </el-table-column>
                  <el-table-column v-else :key="`no-children-${index}`" :label="item.label" align="center"
                      :width="item.width" :prop="item.prop">
                      <template slot-scope="scope">
                          <span>{{ scope.row[item.prop] }}</span>
                      </template>
                  </el-table-column>
              </template>
          </el-table>
      </div>
  </div>
</template>

<script>
export default {
  name: "tableMain",
  props: {
      tableData: {
          type: Array,
          default: () => [],
      },
      height: {
          type: Number,
          default: 0,
      },
      dataType: {
          type: Number,
          default: 1,
      },
  },
  data() {
      return {
          table: [
          ],
          tableA: [
                { label: "供应商", prop: "supplyName", status: true, width: "auto" },
                { label: "明细供应商", prop: "detailSupplyName", status: true, width: "auto" },
                { label: "期初", prop: "initAmount", status: true, width: "100" },
                { label: "入库", prop: "inAmount", status: true, width: "100" },
                { label: "耗用", prop: "theoryAmount", status: true, width: "100" },
                // { label: "实际耗用", prop: "actualOutAmount", status: true, width: "100" },
                { label: "期末(期末+入库-耗用)", prop: "endAmount", status: true, width: "150" },
            ],
            tableB: [
                { label: "供应商", prop: "supplyName", status: true, width: "auto" },
                { label: "明细供应商", prop: "detailSupplyName", status: true, width: "auto" },
                { label: "期初", prop: "initAmount", status: true, width: "100" },
                { label: "入库", prop: "inAmount", status: true, width: "100" },
                { label: "耗用", prop: "actualOutAmount", status: true, width: "100" },
                { label: "期末(期末+入库-耗用)", prop: "endAmount", status: true, width: "150" },
            ],
          tableLoading: false,
      };
  },
  watch: {
    dataType(val) {
         if(val == 3) {
          this.table = this.tableB
         } else {
          this.table = this.tableA
         }
      },
  },
  mounted(){
    this.table = this.tableA
  },
  methods: {
  }
};
</script>